<template>
  <section class="c-step py-4 py-lg-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col col-12 col-md-10 col-lg-8 col-xl-7">
          <div class="text-center mb-4">
            <div class="c-timer fs-40 w-bold darks mb-0">{{ timer }}</div>
            <p class="mb-0 w-sbold fs-18">
              Pregunta {{ currentProgress }} de {{ exam.totalQuestions }}</p>
          </div>
          <section class="bg-white br--small mb-3 mb-lg-4">
            <div v-for="(question, qindex) of exam.questions" :key="question.id">
              <div
                v-if="isActiveQuestion(qindex)"
                class="c-question p-3 p-lg-4"
                :class="{loading : isLoadingQuestion}"
              >
                <h3 class="c-question__title fs-18 w-sbold darks mb-5">
                  <span class="d-block">
                    {{ currentProgress }}. {{ question.title }}
                  </span>
                  <span v-if="question.type == 'checkbox'" class="c-question__type d-block mt-2">
                    <i></i>Respuesta multiple
                  </span>
                  <figure v-if="question.image" class="c-question__attachment mt-3">
                    <img class="of--contain" :src="question.image" alt="" />
                  </figure>
                </h3>
                <TextQuestion
                  v-if="question.alternatives.type == 'text'"
                  class="c-question__alternatives"
                  :question.sync="exam.questions[qindex]"
                  :qindex="qindex">
                </TextQuestion>
                <ImageQuestion
                  v-else-if="question.alternatives.type == 'image'"
                  class="c-question__alternatives"
                  :question.sync="exam.questions[qindex]"
                  :qindex="qindex">
                </ImageQuestion>
              </div>
            </div>
            <div class="d-flex justify-content-end mt-4 mt-lg-3 px-3 px-lg-4 pb-3 pb-lg-4">
              <button
                v-if="!isEndExam"
                class="c-button c-button--primary d-flex align-items-center"
                :class="{loading : isLoadingQuestion}"
                :disabled="!isFilledQuestion && isLoadingQuestion"
                @click="(!isLoadingQuestion) ? nextQuestion() : null">
                {{(isLoadingQuestion) ? 'Guardando...' : 'Siguiente'}}
                <i
                  v-if="!isLoadingQuestion"
                  class="iconf-arrow-right ms-2 d-flex align-items-center">
                </i>
                <img
                  class="c-button__spinner"
                  src="../../assets/images/animations/spinner-white.png"
                  alt="loading"
                />
              </button>
              <button
                v-else
                class="c-button c-button--primary d-flex align-items-center"
                :class="{loading : isFinishingExam}"
                :disabled="!isFilledQuestion && isFinishingExam"
                @click="(!isFinishingExam) ? nextQuestion('finish') : null">
                {{(isFinishingExam) ? 'Procesando...' : 'Finalizar examen'}}
                <img
                  class="c-button__spinner"
                  src="../../assets/images/animations/spinner-white.png"
                  alt="loading"
                />
              </button>
            </div>
          </section>
          <div class="d-flex justify-content-center">
            <button @click="reportIssue" class="c-report-toogle">
              <i class="iconf-warning me-2"></i>
              Reportar problema
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
import { mapActions } from 'vuex';

import TextQuestion from './question/TextQuestion.vue';
import ImageQuestion from './question/ImageQuestion.vue';

export default {
  data() {
    return {
      isLoadingQuestion: false,
      isFinishingExam: false,
      questionsSlider: null,
      currentQuestion: 1,
      intervalTimer: 0,
    }
  },
  components: {
    TextQuestion,
    ImageQuestion,
  },
  props: ['user', 'step', 'exam', 'examSettings'],
  computed: {
    timer: function() {
      let seconds = Math.trunc(this.exam.timer % 60);
      let minutes = Math.trunc((this.exam.timer / 60) % 60);

      if (this.exam.timer >= 0) {
        return `${(minutes >= 10) ? minutes : '0' + minutes}:${(seconds >= 10) ? seconds : '0' + seconds}`;
      } else {
        return '00:00';
      }
    },
    currentProgress: function() {
      return this.exam.answeredQuestions + this.currentQuestion;
    },
    isFilledQuestion: function() {
      let answer = this.exam.questions[this.currentQuestion - 1].answer;

      return (answer && (answer.length || answer > 0)) ? true : false;
    },
    isEndExam: function() {
      return (this.currentQuestion == this.exam.questions.length) ? true : false;
    },
  },
  watch: {
    'exam.timer': function(value) {
      if(value == 0) {
        this.finishExam('timer');
      }
    },
  },
  mounted() {
    this.initTimer();
    this.initQuestions();
  },
  methods: {
    ...mapActions(['openReportModal']),
    initTimer: function() {
      if (this.exam.timer > 0) {
        this.intervalTimer = window.setInterval(() => {
          this.exam.timer--;
        }, 1000);
      } else {
        this.finishExam('timer');
      }
    },
    initQuestions: function() {
      this.$emit('update:exam', {
        ...this.exam,
        totalQuestions: this.exam.questions.length,
        answeredQuestions: this.exam.questions.filter(q => {
          return Array.isArray(q.answer) ? q.answer.length > 0 : !!q.answer;
        }).length,
        questions: this.exam.questions.filter(q => (!q.answer || q.answer.length == 0)),
      });
    },
    isAnsweredQuestion: function(question) {
      return (!question.answer || question.answer.length == 0) ? false : true;
    },
    isActiveQuestion: function(index) {
      return ((this.exam.answeredQuestions + this.currentQuestion) == (index + 1 + this.exam.answeredQuestions)) ? true : false;
    },
    nextQuestion: function(state = 'next') {
      if (state === 'finish') {
        this.isFinishingExam = true;
      }

      this.isLoadingQuestion = true;

      let answers = this.exam.questions.map(q => q.answer).filter((answer, index) => {
        if ((answer.length > 0 || answer > 0) && answer !== '' && (this.currentQuestion -1) === index) {
          return answer;
        }
      });

      const url = `${window.arcux.site}/api/v1/users/${this.user.id}/solved-exams/${this.exam.id}/`;

      fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${window.arcux.token}`,
        },
        body: JSON.stringify({
          alternativeIds: answers.flat(),
        }),
      })
      .then(res => {
        if (res.status == 201 || res.status < 300) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then(data => {
        if (state == 'finish') {
          this.finishExam();
        } else {
          this.currentQuestion++;
        }
      })
      .catch(err => {
        throw err;
      }).finally(() => {
        window.setTimeout(() => {
          this.isLoadingQuestion = false;
        }, 1000)
      });
    },
    finishExam: function(from = 'question') {
      const speciality = (this.$route.params.speciality_id) ? `&specialityId=${this.$route.params.speciality_id}` : '';
      const url = `${window.arcux.site}/api/v1/users/${this.user.id}/solved-exams/${this.exam.id}/complete?courseId=${ this.$route.params.course_id }${speciality}`;

      fetch(url, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${window.arcux.token}`,
        },
      })
      .then(res => {
        if (res.status == 201 || res.status < 300) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then(response => {
        this.$emit('update:exam', {
          ...this.exam,
          approved: response.data.approved,
          nextTime: response.data.nextTime,
          score: response.data.score,
          originalQuestions: this.exam.questions.map((question, index) => {
            return {
              ...question,
              right: Object.values(response.data.questions)[index],
            }
          }),
        });

        if (response.data.approved) {
          let settings = this.examSettings;

          settings.course.certificate = {
            img: response.data.certificate.image,
            pdf: response.data.certificate.pdf,
          };

          if ('courses' in this.examSettings.specialization_courses) {
            if (response.data.certificate.specialization) {
              settings.specialization_courses.spezialization.certificate = {
                img: response.data.certificate.specialization.image,
                pdf: response.data.certificate.specialization.pdf,
              };
            }

            settings.specialization_courses.courses = settings.specialization_courses.courses.map(co => {
              if (co.id == this.$route.params.course_id) {
                return {
                  ...co,
                  certificate: {
                    img: response.data.certificate.image,
                    pdf: response.data.certificate.pdf,
                  },
                };
              } else {
                return co;
              }
            });
          }

          this.$emit('update:examSettings', settings);
        }

        if (from == 'timer') {
          window.clearInterval(this.intervalTimer);
        }

        this.$emit('update:step', 3);
      })
      .catch(err => {
        throw err;
      }).finally(() => {
        this.isFinishingExam = false;
      });
    },
    reportIssue: function() {
      this.openReportModal({
        type: 'exam',
        module: 'exam',
        lection: this.exam.questions[this.currentQuestion - 1].title,
      });

      this.$bvModal.show('modalReport');
    },
  },
}
</script>
